import type { DialogContextType } from './types';

import { createContext } from 'react';

export const ResponseDialogContext = createContext<DialogContextType | undefined>(
  undefined,
);
